module.exports = __webpack_public_path__ + "img/dropdown_large.90cbba1d.svg";